"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectSbLocale = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shapes = require("../../skybase-core/shapes");

var _locales = require("../../skybase-core/locales");

var _utils = require("./utils");

var _sbLocaleI18n = require("./sb-locale-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var injectSbLocale = function injectSbLocale(WrappedComponent) {
  var _class, _temp;

  var wrappedComponentParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var mapStateToProps = function mapStateToProps(state, ownProps) {
    var _getLocaleState = (0, _locales.getLocaleState)(state),
        language = _getLocaleState.language,
        languageCultureMap = _getLocaleState.languageCultureMap;

    return {
      locale: ownProps.locale || (languageCultureMap === null || languageCultureMap === void 0 ? void 0 : languageCultureMap[language]) || 'en'
    };
  };

  return (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps)((_temp = _class = /*#__PURE__*/function (_PureComponent) {
    _inherits(_class, _PureComponent);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "getTimeFormat", function (format) {
        if (format && typeof format === 'string') {
          return format;
        }

        var locale = _this.props.locale;

        var _getFormat = (0, _utils.getFormat)(locale),
            timeFormat = _getFormat.timeFormat;

        if (format && !(0, _utils.isEmptyObject)(format)) {
          return (0, _utils.setTimeFormat)(format);
        }

        return timeFormat;
      });

      _defineProperty(_assertThisInitialized(_this), "getDateFormat", function (format) {
        if (format && typeof format === 'string') {
          return format;
        }

        var locale = _this.props.locale;

        var _getFormat2 = (0, _utils.getFormat)(locale),
            dateFormat = _getFormat2.dateFormat;

        if (format && !(0, _utils.isEmptyObject)(format)) {
          return (0, _utils.setDateFormat)(format, (0, _utils.getFormat)(locale));
        }

        return dateFormat;
      });

      _defineProperty(_assertThisInitialized(_this), "getDateTimeFormat", function (format) {
        if (format && typeof format === 'string') {
          return format;
        }

        var locale = _this.props.locale;

        var _getFormat3 = (0, _utils.getFormat)(locale),
            timeFormat = _getFormat3.timeFormat,
            dateFormat = _getFormat3.dateFormat;

        if (format && !(0, _utils.isEmptyObject)(format)) {
          return format;
        }

        return "".concat(dateFormat, " ").concat(timeFormat);
      });

      _defineProperty(_assertThisInitialized(_this), "format", function (_ref) {
        var value = _ref.value,
            format = _ref.format,
            language = _ref.language;
        var locale = _this.props.locale;
        var finalLocale = language || locale;
        return (0, _utils.formatOutput)({
          value: value,
          format: format,
          language: finalLocale
        });
      });

      _defineProperty(_assertThisInitialized(_this), "formatTime", function (value) {
        return _this.format({
          value: value,
          format: _this.getLocaleFormat().timeFormat
        });
      });

      _defineProperty(_assertThisInitialized(_this), "formatDate", function (value) {
        return _this.format({
          value: value,
          format: _this.getLocaleFormat().dateFormat
        });
      });

      _defineProperty(_assertThisInitialized(_this), "formatDateTime", function (value) {
        var localeFormat = _this.getLocaleFormat();

        return _this.format({
          value: value,
          format: "".concat(localeFormat.dateFormat, " ").concat(localeFormat.timeFormat)
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getLocaleFormat", function (language) {
        var locale = _this.props.locale;
        var finalLocale = language || locale;
        return (0, _utils.getFormat)(finalLocale);
      });

      _defineProperty(_assertThisInitialized(_this), "getWeekDays", function (format) {
        var locale = _this.props.locale;
        var weekDaysFormat = format && format.toLowerCase() === 'short' ? 'short' : 'long';
        return (0, _utils.getWeekDays)({
          format: weekDaysFormat,
          locale: locale
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getMonths", function (format) {
        var locale = _this.props.locale;
        var monthFormat = format && format.toLowerCase() === 'short' ? 'short' : 'long';
        return (0, _utils.getMonths)({
          format: monthFormat,
          locale: locale
        });
      });

      _defineProperty(_assertThisInitialized(_this), "validateTime", function (value, _ref2) {
        var format = _ref2.format,
            language = _ref2.language;
        var locale = _this.props.locale;
        return (0, _utils.isValidTime)(value, {
          format: _this.getTimeFormat(format),
          language: language || locale
        });
      });

      _defineProperty(_assertThisInitialized(_this), "validateDate", function (value, _ref3) {
        var format = _ref3.format,
            language = _ref3.language;
        var locale = _this.props.locale;
        return (0, _utils.isValidDate)(value, {
          format: _this.getDateFormat(format),
          language: language || locale
        });
      });

      _defineProperty(_assertThisInitialized(_this), "validateDateTime", function (value, _ref4) {
        var format = _ref4.format,
            language = _ref4.language;
        var locale = _this.props.locale;
        return (0, _utils.isValidDateTime)(value, {
          format: _this.getDateTimeFormat(format),
          language: language || locale
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getMessages", function () {
        var _ = _this.props.intl.formatMessage;
        return {
          datePlaceholder: _(_sbLocaleI18n.messages.datePlaceholder),
          timePlaceholder: _(_sbLocaleI18n.messages.timePlaceholder),
          dateTimePlaceholder: _(_sbLocaleI18n.messages.dateTimePlaceholder)
        };
      });

      _this.weekDaysFormat = wrappedComponentParams.weekDaysFormat || 'short';
      return _this;
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            weekDaysFormat = _this$props.weekDaysFormat,
            passThroughProps = _objectWithoutProperties(_this$props, ["weekDaysFormat"]);

        var sbLocale = {
          getWeekDays: this.getWeekDays,
          getMonths: this.getMonths,
          getLocaleFormat: this.getLocaleFormat,
          getMessages: this.getMessages,
          format: this.format,
          validateTime: this.validateTime,
          validateDate: this.validateDate,
          validateDateTime: this.validateDateTime,
          formatTime: this.formatTime,
          formatDate: this.formatDate,
          formatDateTime: this.formatDateTime
        };
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({}, passThroughProps, {
          sbLocale: sbLocale
        }));
      }
    }]);

    return _class;
  }(_react.PureComponent), _defineProperty(_class, "displayName", "injectSbLocale(".concat(getDisplayName(WrappedComponent), ")")), _defineProperty(_class, "propTypes", {
    intl: _shapes.intlShape.isRequired,
    locale: _propTypes.default.string.isRequired
  }), _defineProperty(_class, "defaultProps", {}), _temp)));
};

exports.injectSbLocale = injectSbLocale;
//# sourceMappingURL=sb-locale.js.map